module.exports = __webpack_public_path__ + "img/Model.09978bc5.svg";